import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";

@Form ({title: "Embed Panel Config"})
export default class EmbedPanelConfig {

	@Input({type: InputType.TEXT, title: "Embed URL"})
	public embedURL: string;

	@Input({type: InputType.UNIT, title: "Frame Height"})
	public height: string;

	@Input({type: InputType.CHECKBOX, title: "Responsive frame (pym.js)"})
	public responsive: boolean;

	@Input({type: InputType.CHECKBOX, title: "Authenticate with Gateway"})
	public createSession: boolean = false;

	@Input({type: InputType.TEXT, title: "Frame Load Event (pym)"})
	public onLoad: string;

	@Input({type: InputType.TEXT, title: "Frame Unload Event (pym)"})
	public onUnLoad: string;

	@Input({type: InputType.TEXT, title: "Frame Ajax Start Event (pym)"})
	public onAjaxStart: string;

	@Input({type: InputType.TEXT, title: "Frame Ajax Complete Event (pym)"})
	public onAjaxComplete: string;

}



// WEBPACK FOOTER //
// ./src/panels/embed/EmbedPanelConfig.ts